import { useEffect, useState } from 'react';
import { useSubscription } from '@apollo/client';
import gql from 'graphql-tag';

/**
 * Follows the live output of a task run STARTED ELSEWHERE (the runs table, another operator, the
 * auto-trigger) — the run detail page attaches by the run's stored task run id. AppSync does not
 * replay missed messages, so the feed only shows what arrives after mount; the stored rows cover
 * history once the run finishes.
 */
const TASK_LIVE_OUTPUT_SUBSCRIPTION = gql`
  subscription onTaskLiveOutput($taskRunId: String!) {
    onTaskLiveOutput(taskRunId: $taskRunId) {
      taskRunId
      message
      type
    }
  }
`;

export const useTaskLiveFeed = (taskRunId, { onTerminal } = {}) => {
  const [messages, setMessages] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    setMessages([]);
    setError(null);
  }, [taskRunId]);

  useSubscription(TASK_LIVE_OUTPUT_SUBSCRIPTION, {
    variables: { taskRunId },
    skip: !taskRunId,
    onError: (subscriptionError) => {
      setError(`Live progress lost (${subscriptionError.message}) — the run keeps going; refresh for status.`);
    },
    onData: ({ data }) => {
      const payload = data?.data?.onTaskLiveOutput;
      if (!payload) {
        return;
      }
      if (!payload.type || payload.type === 'MESSAGE') {
        setMessages((prev) => [...prev, payload.message]);
        return;
      }
      if (payload.type === 'ERROR') {
        setError(payload.message);
      }
      onTerminal?.(payload);
    }
  });

  return { messages, error };
};
